import { render } from "./ProfileIcon.vue?vue&type=template&id=43cf812a&scoped=true&ts=true&lang=pug"
import script from "./ProfileIcon.vue?vue&type=script&lang=ts"
export * from "./ProfileIcon.vue?vue&type=script&lang=ts"

import "./ProfileIcon.vue?vue&type=style&index=0&id=43cf812a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43cf812a"]])

export default __exports__